import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { formatDateTime, priorityClass, priorityLabel } from '../../utils/labels';
export function MemberAnnouncements() {
  const {
    announcements,
    currentMember
  } = useApp();
  const me = currentMember!;
  const zame = announcements.filter(a => a.prejemniki.includes(me.id));
  const neprebrana = zame.filter(a => !a.prebrali.includes(me.id)).length;
  return <div className="mx-auto max-w-3xl space-y-4" data-id="element-1354" data-mp="3remib29yp68s">
      <div className="flex items-end justify-between gap-3" data-id="element-1355" data-mp="3rfxn95f58k1h">
        <div data-id="element-1356" data-mp="6h44dzx9hnx">
          <h1 className="text-2xl font-semibold text-ink" data-id="element-1357" data-mp="5yvsizzjczn">Obvestila</h1>
          <p className="mt-0.5 text-sm text-ink-muted" data-id="element-1358" data-mp="2fyemrksy6v6m">Uradna sporočila vodstva zbora.</p>
        </div>
        {neprebrana > 0 && <Badge className="bg-purple-50 text-purple-700 border-purple-200" data-id="element-1359" data-mp="2kz2ds6h6fc0u">{neprebrana} neprebrano</Badge>}
      </div>

      <Card className="divide-y divide-line" data-id="element-1360" data-mp="2r390mm4fknh1">
        {zame.map(a => {
        const prebrano = a.prebrali.includes(me.id);
        return <Link key={a.id} to={`/clan/obvestila/${a.id}`} className={`flex items-start gap-3 px-5 py-4 transition-colors duration-150 ease-out hover:bg-canvas ${prebrano ? '' : 'bg-green-50/40'}`} data-id="element-1361" data-mp="310dg633rtkov">
              <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${prebrano ? 'bg-transparent' : 'bg-green-500'}`} aria-hidden="true" data-id="element-1362" data-mp="3505ruoogo6yg" />
              <span className="min-w-0 flex-1" data-id="element-1363" data-mp="3eqgyiizj4u91">
                <span className="flex flex-wrap items-center gap-1.5" data-id="element-1364" data-mp="3ers8x1nhd094">
                  <Badge className={priorityClass[a.prioriteta]} data-id="element-1365" data-mp="3srkygtn9tafi">{priorityLabel[a.prioriteta]}</Badge>
                  {a.zahtevaPotrditev && !prebrano && <Badge className="bg-canvas text-ink-muted border-line" data-id="element-1366" data-mp="3vsmpkqbgf64e">Potrebna potrditev</Badge>}
                </span>
                <span className={`mt-1.5 block text-sm ${prebrano ? 'font-medium text-ink' : 'font-semibold text-ink'}`} data-id="element-1367" data-mp="4mv4448mghnx">
                  {a.naslov}
                </span>
                <span className="mt-0.5 line-clamp-1 block text-[13px] text-ink-muted" data-id="element-1368" data-mp="edfvp7pvolxc">{a.besedilo}</span>
                <span className="mt-1 block text-xs text-ink-muted" data-id="element-1369" data-mp="id8ai25v7ob5">
                  {a.avtor} · {formatDateTime(a.objavljeno)}
                </span>
              </span>
              <ChevronRightIcon className="mt-1 h-4 w-4 shrink-0 text-ink-muted" data-id="element-1370" data-mp="scpemf5gxu50" />
            </Link>;
      })}
      </Card>
    </div>;
}